import {
  useEffect, useRef, useState,
} from "react";
import axios, { AxiosRequestConfig } from "axios";

import GlobalContext from "./globalContext";
import { MIDDLE_URL } from "../../services/config";
import { axiosCashJournalClient } from "../../services/api";

const GlobalProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [isGlobalLoading, setGlobalLoading] = useState(false);
  const [
    axiosConfig,
    setAxiosConfig,
  ] = useState<AxiosRequestConfig>();
  const [axiosResult, setAxiosResult] = useState<any>();
  const [axiosError, setAxiosError] = useState<unknown>();
  const abortControllerRef = useRef<AbortController>(new AbortController());

  useEffect(() => {
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const { signal } = controller;

    setGlobalLoading(true);
    setAxiosResult(undefined);
    setAxiosError(undefined);

    if (axiosConfig) {
      (async () => {
        try {
          const { data } = await axiosCashJournalClient({
            ...axiosConfig,
            url: `${MIDDLE_URL}${axiosConfig.url}`,
            signal,
          });

          setAxiosResult(data);

          // reset abortControllerRef
          abortControllerRef.current = new AbortController();
        } catch (error) {
          if (!axios.isCancel(error)) {
            setAxiosError(error);
          }
        } finally {
          setGlobalLoading(false);
        }
      })();
    } else {
      setGlobalLoading(false);
    }

    return () => {
      // Cancel the request when the component unmounts
      controller.abort();
    };
  }, [axiosConfig]);

  return (
    <GlobalContext.Provider value={{
      isGlobalLoading,
      setGlobalLoading,

      controller: abortControllerRef.current,
      setAxiosConfig,
      axiosResult,
      axiosError,
    }}>
      {
        children
      }
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
